import {Requestor} from 'hegyd/core/resources/assets/js/utils/Requestor.js'
import swal from 'sweetalert2';

export default class CartLineDeletor extends HTMLButtonElement {
    constructor() {
        super();

        this.productId = this.dataset.productId;
        this.returnTemplates = JSON.parse(this.dataset.returnTemplates ?? '[]');
        this.mainContainer = document.getElementById('main-container');
    }

    connectedCallback() {
        this.watch();
    }

    disconnectedCallback() {
        this.unwatch();
    }

    watch() {
        this.addEventListener('click', this.deleteLine.bind(this));
    }

    unwatch() {
        this.removeEventListener('click', this.deleteLine);
    }

    deleteLine() {
        if ( ! this.mainContainer) {
            return;
        }

        this.mainContainer.askToDelete(this.dataset.message, this.dataset.button,() => {
            const requestor = new Requestor();
            requestor.sendRequest( this.dataset.href, 'DELETE', {
                'product_id' : this.productId,
                'return_templates' : this.returnTemplates,
            }, (data) => {
                this.mainContainer.updateCartViews(data);
                swal.close();
            });
        });
    }
}
